export default __webpack_public_path__ + "static/media/icon-checked.b5690b5a.svg";